import type React from 'react';

import DragHandleIcon from 'assets/icons/icn _ 24px _ drag-order-slim.svg?react';
import { useStylesCommon } from 'components/scheduleDisplay/styles';

interface TableDragHandleCellProps {
  className?: string;
}

const TableDragHandleCell: React.FC<React.PropsWithChildren<TableDragHandleCellProps>> = ({ className = '' }) => {
  const { classes } = useStylesCommon(false);
  return (
    <div className={`${classes.tableDragHandleCellWrapper} ${className}`}>
      <DragHandleIcon className={classes.tableDragHandleCell} />
    </div>
  );
};

export default TableDragHandleCell;
